//*******************************************************
import {  Component,  
          ChangeDetectorRef,
          ViewChild 
        }                     from '@angular/core';

import { DatePipe } from '@angular/common';

import { Observable, Subscription }       from 'rxjs';
//*******************************************************
// Router
import { Router, ActivatedRoute }         from '@angular/router';
//*******************************************************
// Firestore 
import { firestorecontrol }               from "../../appfirestore/app.firestore";
//*******************************************************
// Devexpress Components
import {  DxChartComponent,
          DxSchedulerComponent
       }             
       from 'devextreme-angular';
//*******************************************************
// Functions
import { appfunctions  }                  from '../../functions/app.functions';

import {  FormatWidth, 
          formatDate, 
          getLocaleDateFormat,
          getLocaleDateTimeFormat }     from '@angular/common';
//*******************************************************
// Field Definitions
import  {   scheduler,
            appointmentdashboardperiod,
            barchartappointment,
            barchartappointmentsort
        }   from '../../appfirestore/app.fields';
//*******************************************************
@Component(
              {
                  selector: 'app-comappointmentsnapshot',
                  templateUrl: './comappointmentsnapshot.component.html',
                  styleUrls: ['./comappointmentsnapshot.component.scss']
              }
          )
//*******************************************************
export class ComappointmentsnapshotComponent 
  {
    //*******************************************************
    eventid: string = '';
    formheight: number = 0;
    //*******************************************************
    subscriptionscheduler: Subscription;
    subscriptionschedulerlist: scheduler[];
    //*******************************************************
    @ViewChild('barappointmentchart') BarChart: DxChartComponent;
    @ViewChild('scheduleragenda') AgendaScheduler: DxSchedulerComponent;
    //*******************************************************
    appointmentdashboard: Array<appointmentdashboardperiod> = []; // Empty Array

    barchart: Array<barchartappointment> = []; // Empty Array
    barchartsort: Array<barchartappointmentsort> = []; // Empty Array

    barcharttitle: string = 'Appointments Schedule';
    charttooltip: boolean = false;

    agendaageduration: number = 7;
    currentDate: string       = formatDate( new Date(), 'yyyy-MM-dd', 'en' );
    dateformat: string;
    agendasdate: Date;
    agendaedate: Date;

    processbuild: boolean = false;
    //*******************************************************
    constructor (
                  private firestoredata: firestorecontrol, 
                  private appfunction: appfunctions,
                  private datePipe: DatePipe,
                  private ref: ChangeDetectorRef,
                  private _Activatedroute:ActivatedRoute
                ) 
      { 

        this.customizeTooltip = this.customizeTooltip.bind(this);
      }
    //*******************************************************
    ngOnInit(): void 
      {
        //--------------------------------------------------------------------------------------------
        // EventId
        this.eventid     = String(this._Activatedroute.snapshot.paramMap.get("eventid"))
        // Form Height
        this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));

        //   console.log( this.eventid )
        //   console.log( this.formheight )
        //--------------------------------------------------------------------------------------------
        // Date Format
        const shortDateFormat       = getLocaleDateFormat('en-AU' , FormatWidth.Short);
        const shortDateTimeformat   = getLocaleDateTimeFormat( 'en-AU', FormatWidth.Short )    

        this.dateformat     = shortDateFormat; // d/M/yy

        // Build Appointment Dashboard
       // this.build_appointment_dashboard();

        
      
      // Three Process will control Chart updates
      // Locks Chart from Updates starts at 0.50 Sec
      setTimeout( () => {
                         // console.log( '1') 
                          this.BarChart.instance.beginUpdate(); 
   //                     //  this.build_appointment_dashboard();
                        },500
                  )

      // Builds Data Starts at 1.00 Second
      setTimeout( () => {
                        //  console.log( '2') 
                          this.build_appointment_dashboard();
                        },1000
                        )

      // Unlocks Chart at 2 sec
      setTimeout( () => {
                         // console.log( '3') 
                          this.BarChart.instance.endUpdate();

                        },2000
                )

      }
    //*******************************************************  
    ngAfterViewInit() 
      {
        this.ref.detectChanges();

      }
    //*******************************************************
    ngOnDestroy() 
      {
        
        if (typeof this.subscriptionscheduler != 'undefined'  )
          {
            this.subscriptionscheduler.unsubscribe()
          }

      }
   //*******************************************************
    build_appointment_dashboard()
      {
        var currentdate: Date;
        var getdayno: number;
        var getdaydiff: number;
        var lastDayOfMonth: number;
        var timespandesc: string;
        var perioddesc: string;

        var startdate: Date;
        var enddate: Date; 

        var priorBeginDate: Date;
        var priorEndDate: Date;

        var postBeginDate: Date;
        var postEndDate: Date;


        this.appointmentdashboard   = []; // Empty Array
        this.barchart               = [];

        var buildbar: boolean = false;

        currentdate = new Date()
        getdayno    = currentdate.getDay(); // 1=Monday, 7-Sunday

        startdate = currentdate
         
    //   console.log( getdayno )


   //     getdaydiff  =  getdayno - 1
        //     console.log(  getdaydiff )

   //     if (  getdaydiff == 0 )
   //       {
   //         startdate =  currentdate
   //       }
   //     else
    //      {
    //        startdate = new Date()
    //        startdate.setDate( startdate.getDate() + ( getdaydiff * -1 ) )
            
    //      }

      //--------------------------------------------------------------------------------------------
      // Prior Appointments from the start date
      // Prior Perioid
      // console.log( startdate )
      priorEndDate =  new Date(  startdate.getFullYear(), startdate.getMonth(),  startdate.getDate(),0,0,0,0);
      priorEndDate.setDate( priorEndDate.getDate() + -1 )
      console.log( priorEndDate )

      priorBeginDate  = new Date(  priorEndDate.getFullYear(), priorEndDate.getMonth(),  priorEndDate.getDate(),0,0,0,0);
      priorBeginDate.setDate( priorEndDate.getDate() + -1000)

      perioddesc    = 'Prior: ' + this.datePipe.transform(priorEndDate, "dd-MMM-yy");

      timespandesc  = 'Prior: ' + this.datePipe.transform(priorEndDate, "dd-MMM-yy") 

      this.appointmentdashboard.push(
                                        {
                                          orderid: -1,

                                          perioddescription: 'Period--1', 

                                          periodname: perioddesc,

                                          timespandesc: timespandesc,
                                  
                                          startdate: priorBeginDate,
                                  
                                          enddate: priorEndDate,
                                  
                                          noappointments: 0  
                                        }

                                      )

      this.barchart.push
        (
          {
            
            costtype: 'Period--1',
            amount: 0,
            periodname: perioddesc
          }
        )

       //-------------------------------------------------------------------------------------------- 
       // Set Periods 
       for (let i = 0; i < 7; i++) 
          {
            switch ( i )
              {

                // First Month after Prior Array = Pos 1
                case 0:
                  {
                    // console.log( startdate.getFullYear() + ' ' + startdate.getMonth()  + ' ' + startdate.getDate() )
                    startdate = new Date(  startdate.getFullYear(), startdate.getMonth(),  startdate.getDate(),0,0,0,0)
                   
                    enddate = new Date(  startdate.getFullYear(), startdate.getMonth(),  startdate.getDate(),0,0,0,0)
                    enddate.setDate( startdate.getDate() + 6)

                    break;
                  
                  }

                case 1:
                case 2:
                  {
                    startdate = new Date(  enddate.getFullYear(), enddate.getMonth(),  enddate.getDate());
                    startdate.setDate( startdate.getDate() + 1 )

                    enddate = new Date(  startdate.getFullYear(), startdate.getMonth(),  startdate.getDate())
                    enddate.setDate( enddate.getDate()+6)

                    break;

                  }

                case 3:
                  {
                    startdate = new Date(  enddate.getFullYear(), enddate.getMonth(),  enddate.getDate());
                    startdate.setDate( startdate.getDate() + 1 )

                    enddate = new Date(  startdate.getFullYear(), startdate.getMonth(),  startdate.getDate())
                    enddate.setDate( enddate.getDate()+6)

                    // Determine the Last Day of the Calendar Month
                    lastDayOfMonth = new Date(enddate.getFullYear(), enddate.getMonth() + 1, 0).getDate();
                    
                    enddate = new Date(  startdate.getFullYear(), startdate.getMonth(),  lastDayOfMonth)

                    break;

                  }

              // Month Periods
              default:
                  {
                    startdate = new Date(  enddate.getFullYear(), enddate.getMonth(),  enddate.getDate()+1);

                    lastDayOfMonth = new Date(startdate.getFullYear(), startdate.getMonth() + 1, 0).getDate();

                    enddate = new Date(  startdate.getFullYear(), startdate.getMonth(),  lastDayOfMonth)

                    break;
                  }


              }



            timespandesc = this.datePipe.transform(startdate, "dd-MMM-yy") + '<br>' + ' to ' + '<br>' +
                            this.datePipe.transform(enddate, "dd-MMM-yy") 

            if ( i <= 3 )
                {
                  perioddesc    = this.datePipe.transform(startdate, "dd-MMM-yy") + ' to ' +
                                  this.datePipe.transform(enddate, "dd-MMM-yy") 
                }
              else
                {
                  perioddesc    = this.datePipe.transform(startdate, "MMM-yy")
                }

              this.appointmentdashboard.push(
                  {
                    orderid: i,

                    perioddescription: 'Period-' + i,

                    periodname: perioddesc,

                    timespandesc: timespandesc,
            
                    startdate: startdate,
            
                    enddate: enddate,
            
                    noappointments: 0  
                  }

                )

                this.barchart.push
                (
                  {
                    
                    costtype: 'Period-' + i,
                    amount: 0,
                    periodname: perioddesc
                  }
                )


          }
      //--------------------------------------------------------------------------------------------
      // Post Appointments after the last Month Period
      postBeginDate     =  new Date(  this.appointmentdashboard[7].enddate.getFullYear(), this.appointmentdashboard[7].enddate.getMonth(),  this.appointmentdashboard[7].enddate.getDate(),0,0,0,0);
      postBeginDate.setDate( postBeginDate.getDate() + 1 )

      postEndDate  = new Date(  postBeginDate.getFullYear(), postBeginDate.getMonth(),  postBeginDate.getDate(),0,0,0,0);
      postEndDate.setDate( postBeginDate.getDate() + 1000)

      perioddesc    = 'Post: ' + this.datePipe.transform(postBeginDate, "dd-MMM-yy");

      timespandesc  = 'Post: ' + this.datePipe.transform(postBeginDate, "dd-MMM-yy") 

      this.appointmentdashboard.push(
                                        {
                                          orderid: -99,

                                          perioddescription: 'Period--99', 

                                          periodname: perioddesc,

                                          timespandesc: timespandesc,
                                  
                                          startdate: postBeginDate,
                                  
                                          enddate: postEndDate,
                                  
                                          noappointments: 0  
                                        }

                                      )

        this.barchart.push
        (
          {
            
            costtype: 'Period--99',
            amount: 0,
            periodname: perioddesc
          }
        )
        //--------------------------------------------------------------------------------------------  
        if ( this.appointmentdashboard.length > 0 ) 
          {

           
              this.barcharttitle =  this.barcharttitle + ' from ' + 
                                    this.datePipe.transform( this.appointmentdashboard[1].startdate, "dd-MMM-yy") + ' to ' +
                                    this.datePipe.transform( this.appointmentdashboard[7].enddate, "dd-MMM-yy")

            // Determine no of appointments per period 
            for (let i = 0; i < this.appointmentdashboard.length; i++) 
              {
               // console.log(  this.appointmentdashboard[i].orderid )
                this.firestoredata.countappointment_for_period( this.eventid, this.appointmentdashboard[i].orderid, this.appointmentdashboard[i].startdate, this.appointmentdashboard[i].enddate )
                      .then ( ( value ) => {
                                              const nocnt: number = value;

                                              //console.log( this.appointmentdashboard[i].orderid + '-' + nocnt ) 

                                              this.appointmentdashboard[i].noappointments = nocnt;

                                              this.barchart[i].amount = nocnt;

                                           //   console.log( i + ":" +  nocnt )

                                           //   this.barchart.push
                                           //     (
                                           //       {
                                                   
                                            //        costtype: this.appointmentdashboard[i].perioddescription,
                                            //        amount: this.appointmentdashboard[i].noappointments,
                                             //       periodname: this.appointmentdashboard[i].periodname
                                             //     }
                                            //    )

                                            }

                            )

              

              }


             

          }
        //--------------------------------------------------------------------------------------------
        
       // if ( this.appointmentdashboard.length > 0 && buildbar)
       //   {
       //     console.log( this.appointmentdashboard )
       //     for (let i = 0; i < this.appointmentdashboard.length; i++) 
       //       {

        //          console.log( this.appointmentdashboard[i].noappointments )
        //          this.barchart.push
        //                                        (
        //                                          {
        //                                            costtype: this.appointmentdashboard[i].perioddescription,
        //                                          amount: this.appointmentdashboard[i].noappointments,
        //                                            periodname: this.appointmentdashboard[i].periodname
        //                                          }
        //                                        )

      //        }

        //      console.log( this.barchart)

        //  }
       
      }  
    //*******************************************************
    customizeSeries(event: any) 
    {
      
    //  console.log(  event )

    //  switch (   event.argument )
      switch (   event.data.costtype )
      {

        case 'Period--1':  return { type: 'bar', label: { visible: true }, color: '#91a3b0' };

        case 'Period-0':   return { type: 'bar', label: { visible: true }, color: '#91a3b0' };

        case 'Period-1':   return { type: 'bar', label: { visible: true }, color: '#87ceeb' };

        case 'Period-2':  return { type: 'bar', label: { visible: true }, color: '#009933' };

        case 'Period-3':  return { type: 'bar', label: { visible: true }, color: '#ff3f7a' };

        case 'Period-4':  return { type: 'bar', label: { visible: true }, color: '#ff3f7a' };

        case 'Period-5':  return { type: 'bar', label: { visible: true }, color: '#ff3f7a' };

        case 'Period-6':  return { type: 'bar', label: { visible: true }, color: '#ff3f7a' };

        case 'Period--99':  return { type: 'bar', label: { visible: true }, color: '#ff3f7a' };


        default:  return {};

      }      
  
    }
    //*******************************************************
    customizeTooltip(event: any) 
    {
     // console.log(  event )
        
      const result = this.appointmentdashboard.find(({ periodname }) => periodname === event.argument);
      return {  text: `${result.timespandesc}` };
   
  }
  
//*******************************************************
onPointHoverChanged( event: any )
    {

      if(event.target.isHovered()) 
        {
       //   console.log(  event.target.argument )
          event.target.showTooltip();
       // console.log('The pointer is over a series');
        } 
      else 
        {
       
          event.target.hideTooltip();
          //  this.BarChart.instance.hideTooltip();
            // console.log('The pointer is not over a series');
        }

    }
  //*******************************************************
  onPointClick(event: any) 
    {
      // console.log( event )

      var filterno: number;

      const result = this.appointmentdashboard.find(({ periodname }) => periodname === event.target.argument);

     console.log( result )
     // console.log(  result.startdate + ' ' + result.enddate )

      switch ( result.orderid )
        {


          case -1:
              {

                filterno                        = result.orderid
                this.agendasdate                = new Date(  result.startdate.getFullYear(), result.startdate.getMonth(),  result.startdate.getDate(),0,0,0,0);
                this.agendaedate                = new Date(  result.enddate.getFullYear(), result.enddate.getMonth(),  result.enddate.getDate() + 1,0,0,0,0);

                //console.log( 'Date:' + this.agendaedate )

                // Controls the Agenda Period
                this.currentDate                = formatDate( this.agendasdate, 'yyyy-MM-dd', 'en' );
                var diff                        = Math.abs( this.agendasdate.getTime() - this.agendaedate.getTime());
                this.agendaageduration          = Math.ceil(diff / (1000 * 3600 * 24)); 

                break

              }

        
          default:
              {

                filterno                        = 15;
              
                this.agendasdate                = new Date(  result.startdate.getFullYear(), result.startdate.getMonth(),  result.startdate.getDate(),0,0,0,0);
                this.agendaedate                = new Date(  result.enddate.getFullYear(), result.enddate.getMonth(),  result.enddate.getDate(),0,0,0,0);

              


                this.currentDate                = formatDate( this.agendasdate, 'yyyy-MM-dd', 'en' );
                var diff                        = Math.abs( this.agendasdate.getTime() - this.agendaedate.getTime())+1;
                this.agendaageduration          = Math.ceil(diff / (1000 * 3600 * 24)); 

                break

              }

        }


      this.subscriptionschedulerlist  = [];

      if ( result.noappointments > 0 )
        {

        //  console.log( 'Days Diff:' +  this.agendaageduration  )

          this.firestoredata.loadscheduler( this.eventid, 100, filterno, '', result.startdate, result.enddate);

          this.subscriptionscheduler = this.firestoredata.getscheduler().subscribe
            ( items => 
              { 
                this.subscriptionschedulerlist = items;

                console.log( this.subscriptionschedulerlist )
              }
            )

        }
      
    }
  //*******************************************************
  customizeAgendaDateNavigatorText = (e) => 
    {

      let formatOptions = { 
                              year:   '2-digit', 
                              month:  'numeric', 
                              day:    'numeric' 
                          };

     // console.log( e )
    
      var formattedStartDate = formatDate(e.startDate,  this.dateformat , 'en');

      var formattedEndDate = formatDate(e.endDate,  this.dateformat , 'en');

    //  var formattedStartDate  = formatDate(this.agendasdate ,  this.dateformat , 'en');

    //  var formattedEndDate    = formatDate(this.agendaedate ,  this.dateformat , 'en');
    
      return formattedStartDate + "-" + formattedEndDate;

    }
  //*******************************************************
  onContentReady( event: any)
    {
     // let toolbarInstance = this.AgendaScheduler.instance

    //  let element = document.querySelectorAll(".dx-scheduler-navigator")
    //  console.log(element )

    }
  //*******************************************************
  onSeriesHoverChanged(e) {
   
    if (e.target) {
      console.log('The pointer is over a series');
    } else {
      console.log('The pointer is not over a series');
    }
  }

  



  
}